import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Label, Input } from '@vebox/etui-system-elements';

const _excluded = ["theme", "isDisabled"];
const RadioLabel = styled(Label).attrs(_ref => {
  let {
      theme,
      isDisabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({
    display: 'flex',
    alignItems: 'center',
    color: isDisabled ? theme.palette.text.disabled : theme.palette.text.secondary,
    mr: `${theme.spacing.xs}px`,
    width: '100%',
    cursor: isDisabled ? 'not-allowed' : 'pointer'
  }, theme.typography.label), props);
})`
  &:last-child {
    margin-right: 0;
  }
`;

const RadioInput = styled(Input)`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
  margin: 0;
`;

const RadioBase = ({
  name,
  value,
  isChecked = false,
  isDisabled = false,
  onChange,
  children,
  styles = {}
}) => {
  const disabled = isDisabled;
  const checked = isChecked;
  return /*#__PURE__*/createElement(RadioLabel, _extends({
    key: value,
    isDisabled: isDisabled
  }, styles === null || styles === void 0 ? void 0 : styles.root), children, /*#__PURE__*/createElement(RadioInput, _extends({
    type: "radio",
    checked: checked,
    name: name,
    value: value,
    onChange: onChange,
    disabled: disabled
  }, styles.input)));
};

export default RadioBase;
